import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type ImagePosition = 'left' | 'right';
type ImageSize = 'normal' | 'tall' | 'square';

@Component({
    selector: 'app-image-text-section',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './image-text-section.component.html',
    styleUrl: './image-text-section.component.scss'
})
export class ImageTextSectionComponent {
    @Input() imageUrl: string = '';
    @Input() imageAlt: string = '';
    @Input() imagePosition: ImagePosition = 'left';
    @Input() imageSize: ImageSize = 'normal'; // normal, tall (segona), square (about2, comunidad1)
    @Input() hasBackgroundImage: boolean = false;
    @Input() backgroundImageUrl?: string;
    @Input() backgroundOpacity: number = 0.6;
    @Input() fetchPriority: 'high' | 'low' | 'auto' = 'auto'; // Para LCP optimization
}
